import { motion } from "framer-motion";
import { User, Building2 } from "lucide-react";
import { useApp } from "@/context/AppProviders";

const icons = [User, Building2];

const Audience = () => {
  const { t } = useApp();
  const a = t.audience;

  return (
    <section
      id="audience"
      data-testid="audience-section"
      className="py-24 sm:py-32 border-t border-border"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
          className="max-w-2xl"
        >
          <p className="font-mono text-sm uppercase tracking-widest text-blue-500">
            {a.label}
          </p>
          <h2 className="font-heading mt-3 text-2xl sm:text-3xl lg:text-4xl font-semibold tracking-tight">
            {a.title}
          </h2>
          <p className="mt-4 text-base leading-relaxed text-muted-foreground">
            {a.subtitle}
          </p>
        </motion.div>

        <div className="mt-14 grid gap-6 md:grid-cols-2">
          {a.cards.map((card, i) => {
            const Icon = icons[i];
            return (
              <motion.div
                key={card.title}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                data-testid={`audience-card-${i}`}
                className="rounded-sm border border-border bg-card p-8 transition-colors duration-200 hover:border-muted-foreground/40"
              >
                <div className="flex items-center gap-4">
                  <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-sm border border-blue-600/30 bg-blue-600/10 text-blue-500">
                    <Icon className="h-6 w-6" strokeWidth={2} />
                  </div>
                  <div>
                    <span className="font-mono text-xs uppercase tracking-wide text-muted-foreground">
                      {card.tag}
                    </span>
                    <h3 className="font-heading text-xl font-medium tracking-tight">
                      {card.title}
                    </h3>
                  </div>
                </div>
                <p className="mt-5 text-sm leading-relaxed text-muted-foreground">
                  {card.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Audience;
